var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1 16.45H2.855A1.858 1.858 0 011 14.597V3.856C1 2.831 1.832 2 2.855 2H15.1c1.023 0 1.856.832 1.856 1.855v10.74a1.858 1.858 0 01-1.856 1.856zM2.855 3.485a.371.371 0 00-.37.372v10.74c0 .205.166.37.37.37H15.1a.371.371 0 00.371-.37V3.856a.371.371 0 00-.37-.372H2.854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6h14.193v1.484H2zm8.075 7.467c.14.14.318.206.496.206a.694.694 0 00.495-.206l1.58-1.58c.3-.309.3-.795-.009-1.113l-1.57-1.57a.706.706 0 00-.992 0 .706.706 0 000 .99l1.14 1.141-1.14 1.141a.706.706 0 000 .991zm-3.273 0c.14.14.318.206.496.206a.694.694 0 00.496-.206.706.706 0 000-.99l-1.132-1.142 1.14-1.14a.706.706 0 000-.992.706.706 0 00-.99 0l-1.58 1.58a.784.784 0 000 1.113l1.57 1.571z"
  }))));
}
export default SvgDevelopmentCenter;